/* oxlint-disable no-restricted-imports */
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cls(...args: ClassValue[]) {
  return twMerge(clsx(args));
}
